/* TAHA SNEAK — garder le panier quand le client ouvre « Commander maintenant » sur une fiche produit.
   EasySell vide le panier et n'y laisse que le produit de la page. Si le client ferme le
   formulaire sans commander, on remet son panier comme avant. */
(function () {
  'use strict';
  var d = document;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BTN = '#es-form-button, .es-form .es-cta-btn';
  var nativeFetch = window.fetch;
  var session = null, timer = null;

  function req(path, body) {
    var opt = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) {
      opt.method = 'POST';
      opt.headers['Content-Type'] = 'application/json';
      opt.body = JSON.stringify(body);
    }
    return nativeFetch.call(window, ROOT + path, opt).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }
  function sig(items) {
    return (items || []).map(function (i) { return i.variant_id + ':' + i.quantity; }).sort().join('|');
  }
  function modalOpen() {
    var m = d.getElementById('easysell-modal');
    return !!m && window.getComputedStyle(m).display !== 'none';
  }

  /* Photo du panier juste avant qu'EasySell le vide */
  window.fetch = function (input, init) {
    var url = String(typeof input === 'string' ? input : (input && input.url) || '');
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (session && !session.taken && method === 'POST' && /\/cart\/clear(\.js)?(\?|$)/.test(url)) {
      var self = this, args = arguments, s = session;
      s.taken = true;
      return req('cart.js').then(function (c) { s.snap = c.items || []; }, function () { s.snap = null; })
        .then(function () { return nativeFetch.apply(self, args); });
    }
    return nativeFetch.apply(this, arguments);
  };

  function restore(items) {
    return req('cart.js').then(function (cur) {
      if (sig(cur.items) === sig(items)) return null;
      return req('cart/clear.js', {}).then(function () {
        if (!items.length) return null;
        return req('cart/add.js', {
          items: items.slice().reverse().map(function (i) {
            var it = { id: i.variant_id, quantity: i.quantity };
            if (i.properties && Object.keys(i.properties).length) it.properties = i.properties;
            if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) it.selling_plan = i.selling_plan_allocation.selling_plan.id;
            return it;
          })
        });
      });
    }).then(function () {
      if (window.TSCart && TSCart.refresh) TSCart.refresh(false);
    }).catch(function () { /* on laisse le panier tel quel */ });
  }

  function end() {
    clearInterval(timer);
    timer = null;
    var s = session;
    session = null;
    if (s && s.taken && s.snap && !s.ordered) restore(s.snap);
  }
  function watch() {
    clearInterval(timer);
    var seen = false, started = Date.now();
    timer = setInterval(function () {
      var open = modalOpen();
      if (open) seen = true;
      if ((seen && !open) || Date.now() - started > 30 * 60 * 1000) end();
      else if (!seen && Date.now() - started > 15000) { clearInterval(timer); timer = null; session = null; }
    }, 300);
  }

  /* Le client ouvre le formulaire depuis la fiche produit */
  window.addEventListener('click', function (e) {
    var pop = e.target && e.target.closest && e.target.closest('.es-popup-button');
    if (!pop || session) return;
    var cl = pop.classList;
    var product = cl.contains('es-popup-button-product') ||
      (!cl.contains('es-popup-button-drawer') && !cl.contains('es-popup-button-cart') && window.ES_CURRENT_PAGE === 'product');
    if (!product) return;
    session = { taken: false, snap: null, ordered: false };
    watch();
  }, true);

  /* Le client envoie la commande (après la confirmation) : on ne touche plus au panier.
     Écoute sur document (capture) : passe après la fenêtre de confirmation, avant EasySell. */
  d.addEventListener('click', function (e) {
    if (!session) return;
    var btn = e.target && e.target.closest && e.target.closest(BTN);
    if (!btn) return;
    var form = btn.closest('form') || btn.closest('.es-form');
    var ok = true;
    if (form) {
      Array.prototype.forEach.call(form.querySelectorAll('input[required], textarea[required]'), function (i) {
        if (!(i.value || '').trim()) ok = false;
      });
      var tel = form.querySelector('input[type="tel"], input[name="phone"]');
      if (tel && (tel.value || '').replace(/\D/g, '').length < 9) ok = false;
    }
    if (ok) session.ordered = true;
  }, true);
})();